import List from "./list/list.store";
import CreateForm from "./form/create_form.store";
import Delete from "./delete/delete.store";
import Details from "./details/staff_details.store";

export default {
  modules: {
    List,
    CreateForm,
    Delete,
    Details,
  },
};
